module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_5_5.27069dd1.png";